<!-- 保单信息 -->
<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div class="title_">
        <div class="cutleft_">保单信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="起止日期">
        <a-date-picker :disabled-date="disabledDate" :disabled="disabledAll" :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" placeholder="开始日期" v-decorator="['baodanData.startdata', { rules: [{ required: true, message: '请选择起始日期！' }] }]" @change="effectiveDateChange" />
        <a-date-picker :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }" style="margin-left: 20px" disabled placeholder="结束日期" v-model="applicantInfoExpireDate" />
        <span style="margin-left: 24px" v-if="planOffsetDay > 0">共{{ planOffsetDay }}天</span>
        <a-radio-group v-model="applicantInfo.mon" @change="onChangemon">
          <a-radio :disabled="disabledAll" v-for="item in guarantPre" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
        </a-radio-group>
      </a-form-item>
      <div class="title_">
        <div class="cutleft_">投保企业信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="投保企业名称">
        <a-input v-model="applicantInfo.name" :disabled="disabledAll" @change="handleName('name')" v-decorator="['applicantInfo.name', { rules: [{ required: true, message: '请输入投保企业名称' }] }]" @blur="e => checkLength(e.target.value, 'applicantInfo.name')" placeholder="请输入投保企业名称"></a-input>
      </a-form-item>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件类型">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'idType')"
              v-decorator="[
                'applicantInfo.idType',
                {
                  rules: [{ required: true, message: '请选择投保企业证件类型' }]
                }
              ]"
              placeholder="请选择投保企业证件类型"
            >
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
					<div class="idNumber-form-item">
						<a-form-item :label-col="{ span: 6 }" label="投保企业证件号码">
							<a-input
								v-model="applicantInfo.idNumber"
								:disabled="true"
								v-decorator="[
									'applicantInfo.idNumber',
									{
										rules: [{ required: true, message: '请输入投保企业证件号码' }]
									}
								]"
								placeholder="请输入投保企业证件号码"
							></a-input>
						</a-form-item>
						<!-- 客服二维码组件 -->
						<customerService></customerService>
					</div>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业性质">
            <a-select placeholder="请选择" :disabled="disabledAll" @change="(value, option) => handleChange(value, 'companytype', option)" v-decorator="['applicantInfo.companytype', { rules: [{ required: true, message: '请选择' }] }]">
              <a-select-option v-for="item in companyPropertyList" :key="item.key" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="行业类别">
            <a-select 
              placeholder="请选择行业"
              :disabled="disabledAll"
              :showSearch="true"
              :filter-option="filterOption"
              @change="(value, option) => handleChange(value, 'industrycode', option)" 
              v-decorator="['applicantInfo.industrycode', { rules: [{ required: true, message: '请选择行业' }] }]"
            >
              <a-select-option v-for="item in industryList" :key="item.key" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :span="24">
        <a-form-item :label-col="{ span: 3 }" label="联系地址">
          <a-col :span="12">
            <a-cascader
              placeholder="请选择"
              :disabled="disabledAll"
              @change="(value, label) => handleChange(value, 'pacCode', label)"
              v-decorator="[
                'applicantInfo.pacCode',
                {
                  rules: [{ required: true, message: '请输入省市区' }]
                }
              ]"
              :options="addressOptions"
              :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children'
              }"
              style="float: left; width: 250px"
            />
          </a-col>
          <a-col :span="12">
            <a-input
              v-model="applicantInfo.detailaddress"
              :disabled="disabledAll"
              @blur="e => checkLength(e.target.value, 'applicantInfo.detailaddress')"
              v-decorator="[
                'applicantInfo.detailaddress',
                {
                  rules: [{ required: true, message: '请输入联系地址' }]
                }
              ]"
              placeholder="请输入联系地址"
              style="float: left; width: 350px; margin-left: 10px"
            ></a-input>
          </a-col>
        </a-form-item>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人姓名">
            <a-input
              v-model="applicantInfo.contactsname"
              :disabled="disabledAll"
              v-decorator="[
                'applicantInfo.contactsname',
                {
                  rules: [{ required: true, message: '请输入联系人姓名' }]
                }
              ]"
              placeholder="请输入联系人姓名"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人电话">
            <a-input
              v-model="applicantInfo.contactsphone"
              :disabled="disabledAll"
              @blur="idPhoneChange"
              v-decorator="[
                'applicantInfo.contactsphone',
                {
                  rules: [
                    { required: true, message: '请输入联系人电话' },
                    { pattern: $regTest.checkPhone, message: '联系人电话不正确' }
                  ]
                }
              ]"
              placeholder="请输入联系人电话"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人邮箱">
            <a-input
              v-model="applicantInfo.email"
              :disabled="disabledAll"
              v-decorator="[
                'applicantInfo.email',
                {
                  rules: [
                    { required: true, message: '请输入联系人邮箱' },
                    { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' }
                  ]
                }
              ]"
              placeholder="请输入联系人邮箱"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="支付方式">
            <a-select
              @change="value => handleChange(value, 'payMethod')"
              style="width: 100%"
              placeholder="请选择支付类型"
              :disabled="disabledAll"
              v-decorator="[
                'applicantInfo.payMethod',
                {
                  rules: [{ required: true, message: '请选择支付类型' }]
                }
              ]"
            >
              <a-select-option v-for="item in payTypeList" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <salInsuredList :disabledAll="disabledAll" :columns="columns" :data="salInsuredList" :effectiveDate="applicantInfo.effectiveDate" @delSelect="delSelectpre" @addSelect="addSelectpre" @EduitSelect="eduitSelect"></salInsuredList>

      <a-row :gutter="16">
        <div class="title_">
          <div class="cutleft_">总保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-form-item label="保费" :label-col="{ span: 1 }">
          <a-col :span="6">
            <a-input v-model="applicantInfo.totalPremium" disabled style="width: 130px" addonAfter="元" />
          </a-col>
          <a-col>
            <a-button class="btn_color" :disabled="disabledAll" type="primary" @click="changePremium">修改保费</a-button>
          </a-col>
        </a-form-item>
      </a-row>
      <a-row :gutter="24" class="btn_list" v-show="disabledAll">
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
        <a-checkbox :disabled="!agreementAllRead" @change="onChangeyueduBtn" style="margin-bottom: 20px"> 投保人已充分阅读、理解并同意<fileView></fileView> </a-checkbox>
      </a-row>
      <a-row class="btn_list">
        <a-col :span="24">
          <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
            <a-button class="btn_color" type="primary" :loading="submitLoad1" v-show="!disabledAll" @click="handleSubmit('eduit')">保存订单</a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="fastInsure">
              立即投保
            </a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="gonOne">编辑</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 修改保费modal -->
    <a-modal v-model="modalVisible" title="修改保费" cancelText="取消" okText="确定" @ok="handleOk">
      <div v-for="(item, key) in addPcontent" :key="key">
        <div v-if="viewPcontent[key] > 0">
          请输入职业{{ key }}类保费(如不输入则按原值({{ viewPcontent[key] }})计算)：
          <a-input-number class="level_" :min="parseFloat(viewPcontent[key])" v-model="addPcontent[key]" />
        </div>
      </div>
    </a-modal>
    <!-- 支付的弹窗 -->
    <a-modal class="myModal_" width="500px" title="支付确认" forceRender v-model="showPaySure" @ok="paySure" okText="确定" cancelText="关闭">
      <p
        style="
          text-align: center;
          font-size: 18px;
          margin-bottom: 0;
          padding: 20px;
          line-height: 30px;
        "
      >
        您投保的{{ productName() }}需支付保费 <span style="color: #fe8f2d; font-weight: bold"> {{ applicantInfo.totalPremium }} </span>&nbsp;元
      </p>
    </a-modal>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import Vue from 'vue'
import moment from 'moment';
import salInsuredList from './salInsuredList';
let DATA = require('../data').default;
import { policyMixin } from '@/mixins/policyMixin.js';
import { idNumberMixins } from '@/mixins/idNumberMixins.js';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { salInsuredList },
  mixins: [policyMixin, idNumberMixins],
  data() {
    //这里存放数据
    return {
      saveBtnShow: false, //保存过
      submitLoad1: false, //保存中
      yueduBtn: false, //阅读中
      showPaySure: false, //支付
      postPolicyData: {}, //要提交的数据
      policyId: '', //支付回来的id
      checkVisible: false, //凭证支付
      showQrcodePayModal: false, // 二维码支付
      industryList: require('../js/industryList.json'), //行业code
      companyPropertyList: require('../js/companyPropertyList.json'),
      /**需要的数据开始 */
      applicantInfo: {
        name: '', //投保企业名称
        idType: '', //证件类型
        idNumber: '', //证件号码
        pacCode: '', //省市区
        address: '', //省市区中文
        detailaddress: '', //详细地址
        companytype: '', //企业性质
        industrycode: '', //行业类别
        contactsname: '', //联系人名称
        contactsphone: '', //联系人电话
        email: '', // 邮箱
        vehicleown: '', // 投保人行业名称
        engineno: '', // 企业性质名称
        remark: 1, //保单备注
        payMethod: '', //支付类型
        totalPremium: 0, //总保费
        expireDate: '', //保单终止时间
        effectiveDate: '', // 保单生效时间
        mon: 1 //保证期限
      },
      //表格的头部
      columns: DATA.columns,
      //表格的数据
      salInsuredList: [],
      rate: 0.2, //费率
      industrycodeTEXT: '', //四级行业的文本
      mobilestringcode: '0;0;0;0;0', //每一类添加的保费
      maxType: 1, //最大类别
      companyCode: '01', //企业性质
      planinfos: '0;0;0', //基础保费
      perRiskInfo: '', //险种类
      evidenceNumber: '', //凭证号
      riskNumber: {}, //计算保费
      uniqueArr: [], //去重后的人数列表
      //投保人证件类型
      companyIdTypeOptions: DATA.companyIdTypeOptions,
      //投保的天数
      guarantPre: DATA.guarantPre,
      loading: false,
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      RiskInfos: {
        riskInfos: [
          {
            riskCode: '060099', //意外身故、残疾
            dutyCode: '631001',
            amount: 100000,
            premiumAmt: 0,
            riskName: `意外身故、残疾`,
            riskAmountDesc: 100000
          },
          {
            riskCode: '060115', //意外伤害医疗
            dutyCode: '631002',
            amount: 0,
            premiumAmt: 0,
            riskName: `意外伤害医疗`,
            riskAmountDesc: 0,
            nonDeductibleRate: 1
          },
          {
            riskCode: '060044', //意外伤害住院津贴
            dutyCode: '631042',
            amount: 0,
            premiumAmt: 0,
            riskName: `意外伤害住院津贴`,
            riskAmountDesc: 0
          },
          {
            riskCode: '060068', //猝死
            dutyCode: '631068',
            amount: 0,
            premiumAmt: 0,
            riskName: `猝死`,
            riskAmountDesc: 0
          },
          {
            riskCode: '060006', //客运民航意外
            dutyCode: '631006',
            amount: 0,
            premiumAmt: 0,
            riskName: `客运民航意外`,
            riskAmountDesc: 0
          },
          {
            riskCode: '060006', //客运轨道交通意外
            dutyCode: '631008',
            amount: 0,
            premiumAmt: 0,
            riskName: `客运轨道交通意外`,
            riskAmountDesc: 0
          },
          {
            riskCode: '060006', //客运轮船意外
            dutyCode: '631009',
            amount: 0,
            premiumAmt: 0,
            riskName: `客运轮船意外`,
            riskAmountDesc: 0
          },
          {
            riskCode: '060006', //客运汽车意外
            dutyCode: '6310103',
            amount: 0,
            premiumAmt: 0,
            riskName: `客运汽车意外`,
            riskAmountDesc: 0
          },
          {
            riskCode: '060006', //驾乘意外（非营运车辆）
            dutyCode: '6310142',
            amount: 0,
            premiumAmt: 0,
            riskName: `驾乘意外（非营运车辆）`,
            riskAmountDesc: 0
          }
        ],
        salPolicy: {
          productCode: 'DJBXTY2021', //产品code
          planCode: 'DJBXTY2021',
          groupSize: 0, //人数
          creator: '', //用户id
          bracket: 1, //保费期限
          totalPremium: 0, //总保费
          coverageamount: 0 //总保额
        },
        salPolicyExt: {
          isworkheightinvolved: 2,
          occEmpVersion: 0,
          occuRiskPremium: null
        },
        salPolicyHolder: {
          addfifty: '2', // 测算类型
          name: '', //被保人名称
          stature: 2, //是否高空（2-否，1-是）
          vehicleown: '', // 投保人行业名称
          engineno: '' // 企业性质名称
        },
        premiumBaseDtoList: [] //人数
      }, //测算的数据
      modalVisible: false, //修改保费的弹窗
      resultPcontent: {},
      viewPcontent: {}, //展示的保费
      addPcontent: {}, //拷贝的
      creator: '1',
      productCode: '',
      plan: '',
      userParams: '',
      /**需要的数据结束 */
      guapre: 1,
      planOffsetDay: 0,
      baodanData: {
        startdata: ''
      },
      startValues: null,
      linshiContent: {},
      riskInfosAmount: {}, //计算险种的结果
      ZBAOFEI: 0, //原始保费
      addBAOFEI: 0, //修改添加的保费
      orderContent: {}, //订单的数据
      disabledAll: false, //是否是立即投保
      prohibitedIndustries: ['劳务', '人力资源', '职业介绍', '人才服务', '人才介绍', '企业咨询'], //限制行业
      gztypestr: ''
    };
  },
  //监听属性 类似于data概念
  computed: {
    addressOptions() {
      return window.addrescode.filter(e => e.value != '990000' && e.value != '120000');
    },
    applicantInfoExpireDate() {
      var mon = this.applicantInfo.mon;
      var date = this.applicantInfo.effectiveDate;
      let t2;
      if (date && mon) {
        t2 = moment(date)
          .add(mon, 'months')
          .subtract(1, 's');
      }
      return t2;
    }
  },
  //监控data中的数据变化
  watch: {
    'applicantInfo.pacCode'(val) {
      sessionStorage.removeItem('pacCode');
      sessionStorage.setItem('pacCode', val[2].value || null);
    },
    'applicantInfo.industrycode'(val) {
      sessionStorage.removeItem('HYCode');
      sessionStorage.setItem('HYCode', val || null);
    }
  },
  //方法集合
  methods: {
    moment,
    productName() {
      return sessionStorage.getItem('productName')
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    checkLength(value, param) {
      if (param == 'applicantInfo.name') {
        let applicantInfoName = value;
        let valid = this.prohibitedIndustries.every(element => {
          if (applicantInfoName.indexOf(element) != -1) {
            this.$message.error(`投保人名称包含以下关键字拒保：劳务、人力资源、职业介绍、人才服务、人才介绍、企业咨询！`);
            this.form.setFieldsValue({
              applicantInfo: { name: '' }
            });
            return false;
          } else {
            return true;
          }
        });
        if (valid) {
          this.applicantInfo.name = value
          this.queryCompanyCodeByName();
        }
      }
      if (param == 'applicantInfo.detailaddress') {
        if (value.length > 20) {
          this.$message.warning('投保人地址长度必须小于20位');
          this.form.setFieldsValue({
            applicantInfo: {
              detailaddress: ''
            }
          });
        }
      }
    },
    queryCompanyCodeByName() {
      if (!this.applicantInfo.idType) {
        return;
      }
      this.queryCompanyIdNumber(this.applicantInfo.name, this.applicantInfo.idType, this.companyIdTypeOptions);
    },
    gonOne() {
      this.disabledAll = false;
      this.addBAOFEI = this.$accuracy.sub(Number(this.applicantInfo.totalPremium), Number(this.ZBAOFEI));
      
      this.$bus.$emit('disabledBus', false);
      this.$router.push({
        name: 'djcty',
        query: {
          u: this.$route.query.u,
          p: this.$route.query.p,
          sign: this.$route.query.sign,
          planCode: this.$route.query.planCode
        }
      });
    },
    handleName() {
      if (this.salInsuredList.length) {
        this.resultPremiumSum(this.RiskInfos);
      } else {
        this.applicantInfo.totalPremium = 0;
      }
    },
    queryOrderDetails() {
      // 查询保单信息
      let parms = {
        policyId: this.$route.query.policyId
      };
      this.$api.queryOrderDetails(parms).then(res => {
        if (res.data.returnCode == 0) {
          if (res.data.content) {
            this.orderContent = res.data.content;
            this.$store.commit('setOrderContent', this.orderContent);
            if (res.data.content.salInsuredList) {
              //被保人清单
              this.salInsuredList = res.data.content.salInsuredList;
              this.salInsuredList.forEach((element, i) => {
                let str = element.birthDate;
                element.occupation = [element.occupationCode.substring(0, 2), element.occupationCode.substring(0, 4), element.occupationCode]; //职业类别代码
                element['index'] = i + 1;
                element.birthDate = str.replace(/\//g, '-'); //生日
              });
            }
            if (res.data.content.riskInfos) {
              let riskInfos = res.data.content.riskInfos;
              this.$bus.$emit('busRiskInfos', riskInfos);
            }
            if (res.data.content.salPolicy) {
              let salPolicy = res.data.content.salPolicy;
              this.RiskInfos.salPolicy.coverageamount = salPolicy.coverageamount;
              this.policyId = salPolicy.id.toString();
              this.plan = salPolicy.planCode;
              this.applicantInfo.mon = parseInt(salPolicy.bracket);
              this.applicantInfo.totalPremium = salPolicy.totalPremium;
              this.applicantInfo.payMethod = salPolicy.payMethod;
              this.creator = salPolicy.creator;
              this.productCode = salPolicy.productCode;
              this.$store.commit('setproductCode', this.productCode);
              this.applicantInfo.effectiveDate = moment(salPolicy.effectiveDate).format('YYYY-MM-DD HH:mm:ss');
              this.baodanData.startdata = this.applicantInfo.effectiveDate;
              this.form.setFieldsValue({
                applicantInfo: {
                  ...salPolicy,
                  effectiveDate: moment(salPolicy.effectiveDate).format('YYYY-MM-DD HH:mm:ss')
                },
                baodanData: {
                  startdata: moment(salPolicy.effectiveDate).format('YYYY-MM-DD HH:mm:ss')
                }
              });
            }
            if (res.data.content.salPolicyHolderExt) {
              let salPolicyHolderExt = res.data.content.salPolicyHolderExt;
              this.industrycodeTEXT = salPolicyHolderExt.industryname;
            }
            if (res.data.content.salPolicyHolder) {
              let salPolicyHolder = res.data.content.salPolicyHolder;
              this.applicantInfo.name = salPolicyHolder.name;
              this.mobilestringcode = salPolicyHolder.mobilestringcode;
              this.applicantInfo.companytype = salPolicyHolder.companytype;
              this.applicantInfo.industrycode = salPolicyHolder.industrycode;
              this.applicantInfo.detailaddress = salPolicyHolder.detailaddress;
              this.applicantInfo.vehicleown = salPolicyHolder.vehicleown;
              this.applicantInfo.engineno = salPolicyHolder.engineno;
              this.applicantInfo.address = salPolicyHolder.address;
              this.applicantInfo.pacCode = this.filterPcode([salPolicyHolder.province, salPolicyHolder.city, salPolicyHolder.district] || []).arrCode;
              this.gztypestr = res.data.content.salPolicyHolder.gztypestr;
              this.addPcontent = this.Filtergztypestr(this.gztypestr);
              this.form.setFieldsValue({
                applicantInfo: {
                  ...salPolicyHolder,
                  pacCode: this.filterPcode([salPolicyHolder.province, salPolicyHolder.city, salPolicyHolder.district] || []).code,
                  idType: Number(salPolicyHolder.idType)
                }
              });
            }
            if (res.data.content.salPolicyExt) {
              this.RiskInfos.salPolicyExt.occuRiskPremium = res.data.content.salPolicyExt.occuRiskPremium;
              this.RiskInfos.salPolicyExt.isworkheightinvolved = res.data.content.salPolicyExt.isworkheightinvolved ? res.data.content.salPolicyExt.isworkheightinvolved : '2';
              this.RiskInfos.salPolicyExt.occEmpVersion = res.data.content.salPolicyExt.occEmpVersion;
              this.$bus.$emit('salPolicyExt', res.data.content.salPolicyExt);
            }
            
            this.salInsuredList = res.data.content.salInsuredList;
            this.riskNumber = this.countTimes(this.salInsuredList);
            this.RiskInfos.premiumBaseDtoList = this.numResult(res.data.content.salInsuredList); //人员类别，处理成每一类的人数
            this.RiskInfos.salPolicy = {
              ...this.RiskInfos.salPolicy,
              ...res.data.content.salPolicy
            };
            this.RiskInfos.salPolicyHolder = {
              ...this.RiskInfos.salPolicyHolder,
              ...res.data.content.salPolicyHolder
            };
            this.RiskInfos.riskInfos = res.data.content.riskInfos; //险种信息
          }
        }
      });
    },
    filterPcode(arr) {
      let str;
      if (arr && arr.length) {
        if (isNaN(parseInt(arr[0]))) {
          str = 'text';
        } else {
          str = 'value';
        }
        if (!str) return;
        try {
          var addressOptions = this.$lodash.cloneDeep(this.addressOptions);
          var oneArr = addressOptions.filter(item => item[str] == arr[0]) || [];
          var twoArr = oneArr[0].children.filter(item => arr[1] == item[str]) || [];
          var threeArr = twoArr[0].children.filter(item => item[str] == arr[2]) || [];
          sessionStorage.setItem('pacCode', threeArr[0].value);
        } catch (error) {
          throw new Error(error);
        }
        return {
          code: [oneArr[0] ? oneArr[0].value : '', twoArr[0] ? twoArr[0].value : '', threeArr[0] ? threeArr[0].value : ''],
          arrCode: [oneArr[0], twoArr[0], threeArr[0]]
        };
      }
    },
    Filtergztypestr(data) {
      let newData = data.split(';');
      let obj = {};
      newData.forEach((e, i) => {
        obj[i + 1] = e;
      });
      return obj;
    },
    idPhoneChange(e) {
      let val = e.target.value;
      if (!this.$checkPhone.test(val)) {
        this.$message.error('请输入正确的联系人手机号', 3);
      }
    },
    //确认修改
    handleOk() {
      let numResult = 0;
      let sumZfeiyong = this.sumZfeiyong(this.addPcontent, this.riskNumber);
      
      Object.values(sumZfeiyong).forEach(e => {
        numResult += e;
      });
      
      this.addBAOFEI = this.$accuracy.sub(Number(numResult), Number(this.ZBAOFEI));
      this.applicantInfo.totalPremium = numResult.toFixed(2);
      this.resultPcontent = this.addPcontent;
      this.modalVisible = false;
      this.gztypestr = '';
      this.Eachbaofei(this.viewPcontent, this.resultPcontent);
    },
    //每一类添加的保费
    Eachbaofei(val, newVal) {
      
      let num1 = this.$accuracy.sub(Number(newVal[1]), Number(val[1])) || 0;
      let num2 = this.$accuracy.sub(Number(newVal[2]), Number(val[2])) || 0;
      let num3 = this.$accuracy.sub(Number(newVal[3]), Number(val[3])) || 0;
      let num4 = this.$accuracy.sub(Number(newVal[4]), Number(val[4])) || 0;
      let num5 = this.$accuracy.sub(Number(newVal[5]), Number(val[5])) || 0;
      this.mobilestringcode = [num1, num2, num3, num4, num5].join(';');
    },
    //修改保费
    changePremium() {
      if (JSON.stringify(this.resultPcontent) == '{}') {
        this.$message.error('您还没有计算保费');
        return;
      }
      this.modalVisible = true;
    },
    //反转对象
    resoverObj(obj) {
      var a = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0
        // 6: 0,
      };
      for (const key in obj) {
        a[key] = obj[key];
      }
      return a;
    },
    //统计次数
    numResult(data) {
      
      
      var d = [];
      var b = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0
        // 6: 0,
      };
      data.forEach(e => {
        let levelF = Number(e.occulevel.toString().slice(0, 1));
        if (b[levelF] !== undefined) {
          b[levelF] += 1;
        }
      });
      for (const key in b) {
        var c = {
          occupationKind: '',
          personNum: 0
        };
        c.occupationKind = key;
        c.personNum = b[key];
        d.push(c);
      }
      
      return d;
    },
    //处理险种的拼接字段
    perRiskInfoNew(perRiskInfo) {
      var arrperRiskInfo = [];
      perRiskInfo.forEach(e => {
        if (e.riskCode == 'GSSGCJ' && e.amount > 0) {
          arrperRiskInfo.push('10-工伤身故、残疾-' + e.amount + '-' + e.premiumAmt);
        }
        if (e.riskCode == 'GSSGYL' && e.amount > 0) {
          arrperRiskInfo.push('11-工伤事故医疗费用-' + e.amount + '-' + e.premiumAmt);
        }
        if (e.riskCode == 'TZSBFWW' && e.amount > 0) {
          arrperRiskInfo.push('55-扩展社保范围外医疗费用-' + e.amount + '-' + e.premiumAmt);
        }
        if (e.riskCode == '24HYWXTB' && e.amount > 0) {
          arrperRiskInfo.push('44-24小时意外险特别扩展条款-' + e.amount + '-' + e.premiumAmt);
        }
        if (e.riskCode == 'YWZYJTMC' && e.amount > 0) {
          arrperRiskInfo.push('22-意外住院津贴每次事故-' + e.amount + '-' + e.premiumAmt);
        }
        if (e.riskCode == 'WGF' && e.amount > 0) {
          arrperRiskInfo.push('33-误工费-' + e.amount + '-' + e.premiumAmt);
        }
        if (e.riskCode == 'YCXSCJY' && e.amount > 0) {
          arrperRiskInfo.push('66-一次性伤残就业补助金-' + e.amount + '-' + e.premiumAmt);
        }
        if (e.riskCode == 'SHHLF' && e.amount > 0) {
          arrperRiskInfo.push('77-生活护理费-' + e.amount + '-' + e.premiumAmt);
        }
        if (e.riskCode == 'GSDCGPF' && e.amount > 0) {
          arrperRiskInfo.push('100-工伤定残高赔付标准-' + e.amount + '-' + e.premiumAmt);
        }
      });
      
      return arrperRiskInfo.join('#');
    },
    filter(inputValue, path) {
      return path.some(option => {
        return option.text.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    //测算的总价格
    cesuannum(data) {
      var a = {};
      var resultnum = 0;
      this.RiskInfos.premiumBaseDtoList.forEach(e => {
        a[e.occupationKind] = e.personNum;
      });
      for (const key in a) {
        
        resultnum += a[key] * data[key];
      }
      
      return resultnum.toFixed(2);
    },
    //试算的接口
    resultPremiumSum(data, type) {
      
      // return
      let copyData = this.$lodash.cloneDeep(data);
      copyData.premiumBaseDtoList.forEach(e => {
        e.occupationKind = Number(e.occupationKind.toString().slice(0, 1));
      });
      
      let formData = {
        riskInfos: copyData.riskInfos.filter(item => item.amount > 0), //险种信息
        salPolicy: {
          planCode: this.plan || 'DJBXTY2021', //产品计划 （固定值ConstructAccident）
          productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
          creator: this.creator,
          bracket: copyData.salPolicy.bracket, //保费期限
          groupSize: this.salInsuredList.length || 0
        },
        salPolicyExt: {
          isworkheightinvolved: copyData.salPolicyHolder.stature,
          occEmpVersion: this.fileCodeContent.id
        },
        salPolicyHolder: {
          addfifty: '2', // 测算类型
          stature: copyData.salPolicyHolder.stature //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: copyData.premiumBaseDtoList.filter(item => item.personNum > 0) //人数
      };
      // return
      this.applicantInfo.totalPremium = 0;
      this.$api.calPremiumEmployer(formData).then(res => {
        
        if (res.data.success) {
          let datas = res.data.content;
          this.riskInfosAmount = datas;
          this.addBAOFEI = 0;
          
          type == 'eduit' ? '' : (this.gztypestr = '');
          this.resultPcontent = datas.occuLevelSingalPrem;
          let showContent = this.$lodash.cloneDeep(datas.occuLevelSingalPrem);
          this.viewPcontent = showContent; //文案展示保费，恒定不变，做限制
          this.RiskInfos.salPolicy.coverageamount = datas.coverageamount;
          if (type != 'eduit') {
            this.addPcontent = this.resoverObj(this.$lodash.cloneDeep(this.viewPcontent)); //修改，最后复制的对象
          }
          if (!this.disabledAll) {
            this.applicantInfo.totalPremium = datas.totalPremium; //总保费
          }
          this.ZBAOFEI = this.$lodash.cloneDeep(datas.totalPremium);
          this.RiskInfos.salPolicyExt.occuRiskPremium = JSON.stringify(datas.occuLevelDutyPremium);
        } else {
          this.applicantInfo.totalPremium = 0;
          this.$message.error(res.data.returnMsg + '错误');
        }
      });
    },
    //选择天数的
    onChangemon(e) {
      
      
      this.applicantInfo.mon = e.target.value;
      this.RiskInfos.salPolicy.bracket = this.applicantInfo.mon;
      if (this.RiskInfos.premiumBaseDtoList.length) {
        this.resultPremiumSum(this.RiskInfos);
      }
      if (this.applicantInfo.effectiveDate) {
        let end = moment(this.startValues)
          .add(this.applicantInfo.mon, 'month')
          .subtract(1, 'days');
        let offsetDay = end.diff(this.startValues, 'days') + 1;
        this.planOffsetDay = offsetDay;
        this.form.setFieldsValue({ expireDate: end });
      }
    },
    //处理时间的
    effectiveDateChange(date1, date) {
      this.applicantInfo.effectiveDate = date || '';
    },
    //开始时间
    disabledDate(current) {
      var dd = new Date();
      dd.setDate(dd.getDate() + 1); //获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
      var time = y + '-' + m + '-' + d;
      var currents = moment(time);
      return current && current < currents;
    },
    //提交的去重
    unique(arr, attribute) {
      var new_arr = [];
      var json_arr = [];
      for (var i = 0; i < arr.length; i++) {
        if (new_arr.indexOf(arr[i][attribute]) == -1) {
          //  -1代表没有找到
          new_arr.push(arr[i][attribute]); //如果没有找到就把这个name放到arr里面，以便下次循环时用
          json_arr.push(arr[i]);
        }
      }
      return json_arr;
    },
    salInsuredListFn(data) {
      data.filter(e => {
        delete e['occupation'];
        delete e['termOfValidity'];
        delete e['uniqueid'];
        delete e['type'];
        delete e['height'];
        
        switch (e['gender']) {
          case '男':
          case 'M':
            e['gender'] = 'M';
            break;
          case '女':
          case 'F':
            e['gender'] = 'F';
            break;
        }
        e['beneficialType'] = 1;
        e['premium'] = this.addPcontent[e.occulevel];
        e['occulevel'] = e.occulevel.toString().indexOf('类') > -1 ? Number(e.occulevel.toString().slice(0, 1)) : Number(e.occulevel);
      });
      return data;
    },
    //计算总保费
    countTimes(data) {
      var a = [];
      if (data.length) {
        data.forEach(e => {
          let leve = e.occulevel.toString().indexOf('类') > -1 ? Number(e.occulevel.toString().slice(0, 1)) : Number(e.occulevel);
          a.push(leve);
        });
        return a.reduce(function(time, name) {
          if (name in time) {
            time[name]++;
          } else {
            time[name] = 1;
          }
          return time;
        }, {});
      } else {
        return {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
          // 6: 0,
        };
      }
    },
    //计算总保费
    sumZfeiyong(content, riskNumber) {
      var jichu = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0
        // 6: 0,
      };
      for (const key in content) {
        jichu[key] = this.$accuracy.mul(Number(content[key]), Number(riskNumber[key] || 0));
      }
      
      return jichu;
    },
    //计算费率
    sumrate(isHighWork, data, bracket) {
      
      var a = [];
      data.forEach(e => {
        a.push(e.occulevel.toString().slice(0, 1));
      });
      this.maxType = Math.max(...a);
      var is45 = a.some(val => {
        return val == '4' || val == '5';
      });
      if (is45 || isHighWork == '1') {
        let rate = {
          1: 0.4,
          3: 0.4,
          6: 0.7,
          12: 1.0
        };
        this.rate = rate[bracket];
      } else {
        let rate = {
          1: 0.2,
          3: 0.4,
          6: 0.7,
          12: 1.0
        };
        this.rate = rate[bracket];
      }
    },
    //拼接gztypestr字段
    gztypestrPin() {
      let a2 = this.resultPcontent;
      return this.gztypestr ? this.gztypestr : Object.values(a2).join(';');
    },
    //计算数组之和
    sumarr(arr) {
      return Object.values(arr).reduce(function(prev, cur) {
        return this.$accuracy.add(Number(prev), Number(cur));
      });
    },
    //处理险种信息
    filterRiskInfo(data) {
      data.forEach(e => {
        if (e.dutyCode == '631001' && e.riskCode == '060099') {
          e.premiumAmt = this.$accuracy.add(Number(this.riskInfosAmount[e.dutyCode] || 0), Number(this.addBAOFEI));
        } else {
          e.premiumAmt = this.riskInfosAmount[e.dutyCode] || 0;
        }
      });
      
      return data.filter(item => item.amount > 0);
    },
    //理解并阅读
    onChangeyueduBtn(e) {
      this.yueduBtn = e.target.checked;
    },
    //最后的提交
    handleSubmit(type) {
      this.form.validateFields((err, values) => {
        if (!err) {
          let base = this.applicantInfo;
          let gztypestrPin = this.gztypestrPin();
          if (!gztypestrPin) {
            this.$message.warning('请先进行试算！');
            return;
          }
          if (this.salInsuredList.length < 3) {
            this.$message.warning('投保人须为团体，每张保单不少于3人投保，且需投保同一方案。');
            return;
          }
          let num45 = 0 // 四五类职业人数
          let numAll = 0 // 全部人数
          this.salInsuredList.forEach(item => {
            let occupationKind = Number(`${item.occulevel}`.slice(0, 1))
            numAll += 1
            if(occupationKind == '4' || occupationKind == '5') {
              num45 += 1
            }
          })
          if(num45 > 0 && numAll < 21) {
            this.$message.warning('4-5类职业起保人数需在20人以上。');
            return;
          }

          let UNname = '天津';
          if (UNname.indexOf(values.applicantInfo.name) > -1) {
            this.$message.warning('本产品不承保天津及所辖地区的企业。');
            return;
          }
          let pacCode = sessionStorage.getItem('pacCode') || null;
          let HYCode = sessionStorage.getItem('HYCode') ? sessionStorage.getItem('HYCode').split(',') : [];
          if (pacCode == '320582' || pacCode == '320581' || pacCode == '320583') {
            this.$message.error(`注册地或营业地在江苏省-苏州市-昆山市、常熟市及张家港市地区的企业，不在投保范围内，请检查后重新上传！`);
            return;
          }
          if (pacCode) {
            if (pacCode.toString().slice(0, 5) == '4407') {
              if (HYCode[1] == 'C21' || HYCode[2] == 'C201') {
                this.$message.error(`注册地或营业地在广东省-江门市地区的家具木材制造业，不在投保范围内，请检查后重新上传！`);
              }
              return;
            }
          }

          let ageStatus = true;
          this.salInsuredList.forEach(e => {
            let age = this.$tools.jsGetAge(e.birthDate, moment(this.applicantInfo.effectiveDate).format('YYYY-MM-DD'));
            if (age < 16 || age > 65) {
              this.$message.error(`投保人年龄${e.birthDate}截止到保单生效日期不满足16-65周岁，请修改后再试！`);
              ageStatus = false;
              return;
            }
          });
          if (!ageStatus) {
            return;
          }
          if (Number(base.totalPremium) < 1000) {
            this.$message.error('保费不能低于1000，请重新输入保费', 3);
            return;
          }
          let riskInfos = [];
          if (type == 'eduit') {
            riskInfos = this.filterRiskInfo(this.RiskInfos.riskInfos, 'eduit');
          } else {
            riskInfos = this.RiskInfos.riskInfos;
          }
          let data = {
            salInsuredList: this.salInsuredListFn(this.salInsuredList), //表格的数据
            salPolicy: {
              //保单信息
              planCode: this.plan || 'DJBXTY2021', //产品计划 （固定值ConstructAccident）
              productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
              creator: this.creator,
              id: this.policyId,
              effectiveDate: moment(values.baodanData.startdata).format('YYYY-MM-DD'), //startTime  保单生效时间
              expireDate: moment(this.applicantInfoExpireDate).format('YYYY-MM-DD'), //endTime   保单终止时间
              payMethod: values.applicantInfo.payMethod, //支付类型”
              bracket: this.RiskInfos.salPolicy.bracket, //页面选择的保障期间（几个月就传几，整数）
              groupSize: this.salInsuredList.legnth || 0, //投保人数
              totalPremium: base.totalPremium, //totalPremium  总保费
              remark: values.applicantInfo.remark, //备注
              ordertraceno: '', //"凭证支付时的凭证号",
              coverageamount: this.RiskInfos.salPolicy.coverageamount
            },
            salPolicyExt: {
              isworkheightinvolved: this.RiskInfos.salPolicyHolder.stature, //是否高空作业
              occEmpVersion: this.fileCodeContent.id,
              occuRiskPremium: this.RiskInfos.salPolicyExt.occuRiskPremium
            },
            salPolicyHolderExt: {
              industryname: this.industrycodeTEXT
            },
            salPolicyHolder: {
              //投保人信息
              planinfos: this.planinfos, //
              addfifty: this.RiskInfos.salPolicyHolder.addfifty, //测算类型
              type: 'C', //固定值
              name: values.applicantInfo.name, //name  投保人名称
              idType: values.applicantInfo.idType, //证件类型
              idNumber: values.applicantInfo.idNumber, //certNo   证件号码
              address: this.applicantInfo.address, //省市区中文
              detailaddress: values.applicantInfo.detailaddress, //详细地址
              companytype: values.applicantInfo.companytype, //企业性质
              contactsname: values.applicantInfo.contactsname, //联系人姓名
              contactsphone: values.applicantInfo.contactsphone, //联系人电话
              telephone: values.applicantInfo.contactsphone, //联系人电话
              email: values.applicantInfo.email, //联系人邮箱
              vehicleown: this.applicantInfo.vehicleown, // 投保人行业名称
              engineno: this.applicantInfo.engineno, // 企业性质名称
              industrycode: values.applicantInfo.industrycode, //行业类型
              province: base.pacCode[0] ? base.pacCode[0].text : undefined, //省
              city: base.pacCode[1] ? base.pacCode[1].text : undefined, //市
              district: base.pacCode[2] ? base.pacCode[2].text : undefined, //区
              addresscode: `${base.pacCode[0].value}-${base.pacCode[1].value}-${base.pacCode[2].value}`,
              gztypestr: this.gztypestrPin(),
              stature: this.RiskInfos.salPolicyHolder.stature, //"是否高空，是：1，否：2，默认2"
              mobilestringcode: this.mobilestringcode //每一类添加的保费
            },
            riskInfos: riskInfos
          };
          this.postPolicyData = data;
          if (this.$route.query.policyId) {
            this.postPolicyData.salPolicy.policyId = this.$route.query.policyId;
          }
          this.$store.commit('setproductCode', this.productCode);
          this.submitLoad1 = true;
          this.axiosPolicy(type); // 保存订单是 直接保存
        } else {
          this.$message.error('请填写完整提交的数据');
        }
      });
    },
    //立即投保
    fastInsure() {
      if (!this.yueduBtn) {
        this.$message.warning('请确认已充分阅读、理解并同意《保险条款》《投保须知》《责任免除》', 2);
        return;
      }
      this.handleSubmit('policy');
    },
    axiosPolicy(type) {
      //提交保单
      this.$api
        .addPAPolicy(this.postPolicyData)
        .then(res => {
          if (res.data.returnCode == '00') {
            
            this.showPaySure = false;
            this.saveBtnShow = true;
            this.policyId = res.data.content;
            if (type == 'policy') {
              this.showPaySure = true;
            } else {
              this.$message.success('保存成功！');
              this.$router.push({
                name: 'djcty',
                query: {
                  u: this.$route.query.u,
                  p: this.$route.query.p,
                  sign: this.$route.query.sign,
                  policyId: this.policyId,
                  planCode: this.$route.query.planCode,
                  continuation: '1'
                }
              });
              this.disabledAll = true;
              this.$bus.$emit('disabledBus', true);
            }
          }
        })
        .finally(() => {
          this.submitLoad1 = false;
        });
    },
    paySure() {
      //支付确认
      this.showPaySure = false;
      this.submitLoad1 = false;
      this.submitLoad2 = false;
      this.$payModal({
        show: true,
        type: 'djcty', //产品类型
        policyId: this.policyId, //产品id
        creator: this.creator, //用户id
        payMethod: this.applicantInfo.payMethod, //支付方式
        productCode: this.$route.query.p, //产品code
        totalPremium: this.applicantInfo.totalPremium, //支付总金额
        name: this.applicantInfo.name
      });
    },
    handleChange(value, type, label) {
      if (type == 'pacCode') {
        this.applicantInfo[type] = label;
        this.applicantInfo.address = label.length ? label[0].text + label[1].text + label[2].text : '';
        sessionStorage.setItem('pacCode', value[1]);
      } else {
        this.applicantInfo[type] = value;
      }
      if (type == 'companytype') {
        this.applicantInfo.engineno = label.componentOptions.children[0].text || '';
      }
      if (type == 'industrycode') {
        this.applicantInfo.vehicleown = label.componentOptions.children[0].text || '';
        this.industrycodeTEXT = label.componentOptions.children[0].text || '';
      }
      if (type == 'idType') {
        this.queryCompanyCodeByName();
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const { u, p } = this.$route.query;
    this.creator = u;
    this.productCode = p;
    this.plan = p || 'DJBXTY2021';
    this.userParams = {
      //从地址中获取
      userId: u,
      productCode: p
    };
    if (this.$route.query.policyId) {
      this.queryOrderDetails();
      this.disabledAll = true;
    } else {
      this.disabledAll = false;
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$bus.$on('onRiskInfos', data => {
      let strdata = this.$lodash.cloneDeep(data);
      
      this.RiskInfos.riskInfos = strdata.riskInfos;
      this.RiskInfos.salPolicy = strdata.salPolicy;
      this.RiskInfos.salPolicyHolder = strdata.salPolicyHolder;
      this.applicantInfo.mon = Number(strdata.salPolicy.bracket);
      this.applicantInfo.name = strdata.salPolicyHolder.name;
      
      if (this.RiskInfos.premiumBaseDtoList.length) {
        this.resultPremiumSum(this.RiskInfos);
      } else {
        this.applicantInfo.totalPremium = 0;
      }
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {
    this.$bus.$off('onRiskInfos');
    this.$bus.$off('resultPcontent');
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.avatar-uploader >>> .ant-upload {
  width: 128px;
  height: 128px;
}

.avatar-uploader >>> .ant-upload img {
  width: 100%;
  height: 100%;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.btn_color {
  margin: 0 20px;
}
</style>
